import * as React from 'react';
import { BaseSvg, SVGIconProps } from './BaseSvg';

export const MusicNote: React.FC<SVGIconProps> = ({ size = 16, color = '#262E3F', ...props }) => (
  <BaseSvg width={size} height={size} viewBox="0 0 16 16" {...props}>
    <path
      d="M8 2v7.033a2.665 2.665 0 0 0-1.333-.366 2.666 2.666 0 1 0 0 5.333 2.666 2.666 0 0 0 2.666-2.667V4.667H12V2H8Z"
      fill={color}
    />
  </BaseSvg>
);
